/* Messe-Shop24 – Produktanfrage-Modal: öffnen / schließen / Erfolgsscreen
   Ersetzt das Inline-Skript aus sections/main-product.liquid (Canopy 6.3.1 live, Z. 3063–3170).

   Änderung gegenüber 6.3.1: Der Tausch „In den Warenkorb“ ↔ „Jetzt anfragen“ passiert nicht mehr
   per JS. Canopy 7 rendert den Kaufbereich bei jedem Variantenwechsel serverseitig neu
   (data-dynamic-variant-content), die Entscheidung trifft snippets/ms-pdp-ist-anfrage.liquid.
   Deshalb hier nur noch Event-Delegation – neu gerenderte Buttons funktionieren ohne Neu-Binden.
   Eigene Datei: wird von Canopy-Updates nicht überschrieben. */
(function () {
  if (window.msPdpAnfrage) return;
  window.msPdpAnfrage = true;

  function overlay() { return document.getElementById('anfrageModal'); }

  function oeffnen() {
    const el = overlay();
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const feld = el.querySelector('input:not([type="hidden"]):not([readonly])');
    if (feld) feld.focus();
  }

  function schliessen() {
    const el = overlay();
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-anfrage-modal-trigger')) { e.preventDefault(); oeffnen(); return; }
    if (e.target.closest('#anfrageModalClose, #anfrageSuccessClose')) { schliessen(); return; }
    if (e.target === overlay()) schliessen();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay() && overlay().classList.contains('is-open')) schliessen();
  });

  /* Erfolgsscreen nach Versand (?anfrage_sent=true) */
  function erfolg() {
    if (!window.location.search.includes('anfrage_sent=true')) return;
    const successBody = document.getElementById('anfrage-success-body');
    const formBody = document.getElementById('anfrage-form-body');
    const formFooter = document.getElementById('anfrage-form-footer');
    if (successBody) {
      successBody.style.display = 'block';
      if (formBody) formBody.style.display = 'none';
      if (formFooter) formFooter.style.display = 'none';
    }
    oeffnen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', erfolg);
  else erfolg();
})();
